import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Switch, Card, Button, Slider, Tooltip } from 'antd'
import React from 'react'
import SiloLightingTemperature from './SiloLightingTemperature';
import SiloBackgroundColor from './SiloBackgroundColor';
export default function LightingSetting(props) {

  return (
    <>
        <SiloBackgroundColor {...props}/>
        <div style={{marginTop:"5px"}}>
            <div style={{display:"flex", alignItems:"center", position:"relative"}}>
                <span className='manrope f-14 black silo-heading-main'>
                    Lighting
                </span>
                <Tooltip title={<span className='manrope f-12'>The lighting is to show direction and not intensity of light. The lighting here is more intense than what will be in the rendered images.</span>}>
                    <InfoCircleOutlined style={{marginLeft:"5px"}} />
                </Tooltip>
                <div style={{display:"flex", alignItems:"center", position:"absolute", right:"8%"}}>
                    <span className='manrope f-14'>
                        Preview
                    </span>
                    <Switch 
                        checkedChildren={<span className='manrope f-12'>Lighting Mode</span>}
                        unCheckedChildren={<span className='manrope f-12'>Model Mode</span>}
                        style={{marginLeft: 8}}
                        checked={props.greyMat}
                        onChange={(val) => {
                            props.setGreyMat(val)
                        }}
                    />
                    <Tooltip title={<span className='manrope f-12'>Change Material to see a better effect of lighting on the model</span>}>
                        <InfoCircleOutlined style={{marginLeft:"5px"}} />
                    </Tooltip>
                    
                </div>
            </div>
            <div className='custom-scroll' style ={{display:"flex", flexWrap:'wrap', height:'20vh', alignContent:"flex-start", marginTop:"3%", overflowY:"scroll"}}>
            <Card 
                hoverable 
                style={{height:"17vh", width:"22%", borderRadius:"4px", margin:"4px", boxShadow:"0px 2px 0px 0px #0000000B"}}                                
                className={props.camera[props.perspective]['rig_name'] == 'default' && !props.shadowsRig && "default" == props.camera[props.perspective]['lighting'] ? "bordered-card" : "non-bordered-card"}
                onClick={() => {
                    props.setShadowsRig(false);
                    props.setLight("default");
                    props.setRigForCamera("default");
                }}
            >
                <img src={`/img/default.jpg`} style={{width:"90%", borderRadius:"4px", marginTop:"6%"}} alt ={'Silo Lighting - Default'} />
                <span style={{textAlign:'center', height:"5vh", padding:"8%"}} className='manrope f-10 black'>DEFAULT</span>
            </Card>
            <Card 
                hoverable 
                style={{height:"17vh", width:"22%", borderRadius:"4px", margin:"4px", boxShadow:"0px 2px 0px 0px #0000000B"}}                                
                className={props.camera[props.perspective]['rig_name'] == 'default' && props.shadowsRig && "default" == props.camera[props.perspective]['lighting'] ? "bordered-card" : "non-bordered-card"}
                onClick={() => {
                    props.setShadowsRig(true);
                    props.setLight("default");
                    props.setDropShadows(false);
                    props.setRigForCamera("default");
                }}
            >
                <img src={`/img/default.jpg`} style={{width:"90%", borderRadius:"4px", marginTop:"6%"}} alt ={'Silo Lighting - Default Shadoes' } />
                <span style={{textAlign:'center', height:"5vh", padding:"8%"}} className='manrope f-10 black'>DEFAULT W SHADOWS</span>
            </Card>
                {
                    props.allCustomLightingRigs != undefined && props.allCustomLightingRigs.length > 0 && props.allCustomLightingRigs.map((light, index) => {
                        return <Card 
                            hoverable 
                            style={{height:"17vh", width:"22%", borderRadius:"4px", margin:"4px", boxShadow:"0px 2px 0px 0px #0000000B"}}                                
                            className={props.camera[props.perspective]['rig_name']!= 'default' && light.rig_name == props.camera[props.perspective]['rig_name'] ? "bordered-card" : "non-bordered-card"}
                            onClick={() => {
                                props.setRig(light.id, light.rig_name)
                            }}
                        >
                            <img src={'/img/custom_rig.png'} style={{width:"90%", borderRadius:"4px", marginTop:"6%"}} alt ={'Silo Custom Lighting - ' + index} />
                            <span style={{textAlign:'center', height:"5vh", padding:"8%", wordWrap:"break-word"}} className='manrope f-10 black'>{light.rig_name}</span>                               
                        </Card>
                    })
                }
                {
                    Object.keys(props.lightingData).map((light, index) => {
                        return <Card 
                            hoverable 
                            style={{height:"17vh", width:"22%", borderRadius:"4px", margin:"4px", boxShadow:"0px 2px 0px 0px #0000000B"}}                                
                            className={props.camera[props.perspective]['rig_name'] == 'default' && light == props.camera[props.perspective]['lighting'] ? "bordered-card" : "non-bordered-card"}
                            onClick={() => {props.setLight(light)}}
                        >
                            <img src={`/img/${light}.jpg`} style={{width:"90%", borderRadius:"4px", marginTop:"6%"}} alt ={'Silo Lighting - ' + index} />
                            <span style={{textAlign:'center', height:"5vh", padding:"8%"}} className='manrope f-10 black'>{(light.replaceAll("_", " ")).toUpperCase()}</span>
                        </Card>
                    })
                }
            </div>
            <Button onClick={() => {props.setCustomLightingModal(true)}} style={{marginTop:"15px"}} className='modal-okay-black square invert'>
                <span className={'modal-okay-text white manrope f-14'}>
                    <PlusOutlined style={{marginRight:"5px"}}/>
                    Add Custom Lighting
                </span>
            </Button>
        </div>    

       <SiloLightingTemperature {...props}/>
        
    </>
  )
}
